import React, { useEffect, useState, useRef } from "react";
import { Helmet } from "react-helmet-async";
import HeroSection from "../../components/hero/heroSection";
import "./home.css";
import "../../index.css";
import "../../popUpForms/formModals/formModal.css";
import CardInnovatorShowcase from "./homeCards/cardInnovatorShowcase";
import CardInnovatorShowcasePost from "./homeCards/cardInnovatorShowcase-postShowcase";
import CardSponsorOpportunities from "./homeCards/cardSponsorOpportunities";
import CardScorecardOverview from "./homeCards/cardScorecardOverview";
import CardPreparationMatters from "./homeCards/cardPreparationMatters";
import CardCollaborateWithUs from "./homeCards/cardCollaborateWithUs";
import CardAssessWildfireRisk from "./homeCards/cardAssessWildfireRisk";
import CardSubscribeForUpdates from "./homeCards/cardSubscribeForUpdates";
import CardShareFeedback from "./homeCards/cardShareFeedback";
import CardNeedSupport from "./homeCards/cardNeedSupport";
import CardContributeToTheCause from "./homeCards/cardContributeToTheCause";
import Header from "../Navigation/header";
import Footer from "../Navigation/footer";
import SecondaryMenu from "../Navigation/secondaryMenu";
import PopUpModal from "../../popUpForms/formModals/popUpFormModal";

import { upcomingShowcase } from "../../utils/showcaseDates";

const Home = () => {
  const [isVisible, setIsVisible] = useState();
  const [popUpFormVisible, setPopUpFormVisible] = useState(false);
  const [activeForm, setActiveForm] = useState("");
  const [hoveredTab, setHoveredTab] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleBackToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <Helmet>
      <title>
        Catastrophic Wildfire Prevention Consortium (CWPC) | Prevent Wildfires
      </title>

      <meta
        name="description"
        content="The Catastrophic Wildfire Prevention Consortium (CWPC) helps communities prevent catastrophic wildfires through readiness assessments, scorecards, pilots, and collaboration."
      />

      <link rel="canonical" href="https://preventwildfire.world/" />

      <meta property="og:type" content="website" />

      <meta
        property="og:site_name"
        content="Catastrophic Wildfire Prevention Consortium"
      />

      <meta
        property="og:title"
        content="Catastrophic Wildfire Prevention Consortium (CWPC)"
      />

      <meta
        property="og:description"
        content="CWPC helps communities prevent catastrophic wildfires through readiness tools and collaboration."
      />

      <meta
        property="og:url"
        content="https://preventwildfire.world/"
      />

      <meta
        property="og:image"
        content="https://preventwildfire.world/assets/og-default.jpg"
      />
    </Helmet>
      <HeroSection />
      <SecondaryMenu
        hoveredTab={hoveredTab}
        onTabHover={(tabName) => setHoveredTab(tabName)}
        onTabLeave={() => setHoveredTab(null)}
      />
      <div className="home-card-container">
        <div className="home-card-sub-container large-screen-limit">
          {upcomingShowcase ? (
            <CardInnovatorShowcase
              hoveredTab={hoveredTab}
              onTabHover={(tabName) => setHoveredTab(tabName)}
              onTabLeave={() => setHoveredTab(null)}
            />
          ) : (
            <CardInnovatorShowcasePost
              hoveredTab={hoveredTab}
              onTabHover={(tabName) => setHoveredTab(tabName)}
              onTabLeave={() => setHoveredTab(null)}
            />
          )}
          <CardAssessWildfireRisk
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardScorecardOverview
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardSponsorOpportunities
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />

          <CardPreparationMatters
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardCollaborateWithUs
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />

          <CardSubscribeForUpdates
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardShareFeedback
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardNeedSupport
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />
          <CardContributeToTheCause
            hoveredTab={hoveredTab}
            onTabHover={(tabName) => setHoveredTab(tabName)}
            onTabLeave={() => setHoveredTab(null)}
          />

          <div
            onClick={handleBackToTop}
            className={isVisible ? "back-to-top visible" : "back-to-top"}
            aria-label="Link to go back to the top"
            title="back-to-top"
          >
            <i className="fa-solid fa-circle-arrow-up fa-2xl"></i>
          </div>

          <PopUpModal
            activeForm={activeForm}
            formActiveState={popUpFormVisible}
            setFormActiveState={setPopUpFormVisible}
          />
        </div>
      </div>
    </>
  );
};

export default Home;
